import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import './assets/main.scss';
import VueI18n from 'vue-i18n';
import Vue2TouchEvents from 'vue2-touch-events';
import { messages } from '@/plugins/i18n.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/reset.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import 'typeface-roboto/index.css';
import SizeListener from '@/utils/SizeListener.js';

Vue.use(VueI18n);
Vue.use(ElementUI);
Vue.use(Vue2TouchEvents);
SizeListener.init();

const i18n = new VueI18n({
	locale: 'en', 
	fallbackLocale: 'en',
	messages
});

Vue.config.productionTip = false

new Vue({
	el: '#app',
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app');
